export default __webpack_public_path__ + "static/media/6.b4131242.png";